export function abbreviateNumber(
  val: number | null,
  significantDecimalAt = 1000,
): string {
  if (val === null || (val > -1 && val < 1)) {
    return '0';
  }
  // array of possible suffixes -- we should throw a party if we ever reach 'b' billion
  const suffixList = ['', 'k', 'm', 'b', 't'];
  const divider = 1000;

  // figure out the power to which we need to raise our divider
  // to attain our significant figure value - e.g. 1000 = 1, 1000000 = 2
  const exponent = val > 0 ? Math.floor(Math.log(val) / Math.log(divider)) : 0;

  // get the appropriate suffix according to our exponent e.g. (1000) = 1 = suffixList[1] = k
  const suffix = suffixList[exponent];

  // this computes the value down to our significant figures
  // this gives us a max 3 digit integer and the floating point - e.g. 1000 = 1, 10 = 10, 10500 = 10.5
  const significantValue = val / Math.pow(divider, exponent);

  // convert our value to a string - then
  // if our number is greater than or equal to 1 thousand -- keep the first fraction number if it is greater than or equal to 0.1
  // if our number is less than 1 thousand -- DROP the fraction
  // NOTE: Though it's possible to use the native .toFixed()
  //   the problem is that it will round the fraction - we don't want any rounding

  const truncatedValue =
    val >= significantDecimalAt && significantValue % 1 >= 0.1
      ? significantValue.toString().match(/(^\d*\.[1-9])/)?.[0]
      : Math.trunc(significantValue);

  return `${truncatedValue}${suffix}`;
}

export function abbreviatedNumberTransform(
  val: number | null,
  significantDecimalAt = 1000,
): string {
  return abbreviateNumber(val, significantDecimalAt);
}
